import { rest } from 'utils';

export default {
  create: ({ sshKey }) => rest.post({ baseUrl: 'keymanager', body: sshKey }),
  getAll: () => rest.get({ baseUrl: 'keymanager', url: '?depth=2' }),
  update: ({ id, sshKey }) => rest.put({ baseUrl: 'keymanager', url: `/${id}`, body: sshKey }),
  delete: ({ id }) => rest.delete({ baseUrl: 'keymanager', url: `/${id}` }),
};
